<template>
  <q-banner inline-actions :class="$q.dark.isActive ? 'bg-deep-orange-10' : 'bg-deep-orange-2'">
    <slot />
    <template #action>
      <slot name="action" />
    </template>
  </q-banner>
</template>

<script lang="ts">
export default {
  name: 'WarningBanner'
}
</script>
